import React from 'react'
import { useState,useEffect } from 'react'
import '../../../../../css/public/dashboard/listingcreate.css'
import PageTopbar from '../../../../../components/forms/pagetopbar';
import FormInput from '../../../../../components/forms/formInput';
import FormTextarea from '../../../../../components/forms/formTextarea';
import FormSelect from '../../../../../components/forms/formSelect';
import PageNav from './pageNav';
import BrandsFunctions from '../../../../../functions/public/brands';
import ConditionsFunctions from '../../../../../functions/public/conditions';
import CollectionFunctions from '../../../../../functions/public/collection';
import ProductTypeFunctions from '../../../../../functions/public/productType';
import ListingCreateFunctions from '../../../../../functions/public/listingCreate';
import ColorsFunctions from '../../../../../functions/public/colors';
import Sizes from './sizes';
import Colors from './colors';
import Varients from './varients';
import ImagePicker from '../../../../../components/public/others/imagePicker';
import ListCollection from './listcollection';
import Hashtag from './Hashtags';
import Recommendations from './recommendations';
import ApiUrl from '../../../../../configTools/apiUrl';
import { useNavigate } from 'react-router-dom'

const Index = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const navigate = useNavigate();
    const [page,setPage]= useState(0);
    const [title,setTitle] = useState('');
    const [discription,setDiscription] = useState('');
    const [packaging,setPackaging] = useState({name:'Flyer', value:'1'});
    const [packagingList,setpackagingList] = useState([{name:'Flyer', value:'1'},{name:'Box', value:'2'}]);
    const [hscode,setHscode] = useState('');
    const [weight,setWeight] = useState(0);
    const [pwidth,setWidth] = useState(0);
    const [pheight,setHeight] = useState(0);
    const [plength,setLength] = useState(0);
    const [brand,setBrand] = useState({name:'Select', value:'0'});
    const [brandList,setBrandList] = useState([]);
    const [condition,setCondition] = useState({name:'Select', value:'0'});
    const [conditionList,setConditionList] = useState([]);
    const [category,setCategory] = useState({name:'Select', value:'0'});
    const [categoryList,setCategoryList] = useState([]);
    const [subcategory,setSubcategory] = useState({name:'Select', value:'0'});
    const [subcategoryList,setSubcategoryList] = useState([]);
    const [allcategoryList,setAllCategoryList] = useState([]);
    const [state,setState] = useState({name:'Fashion', value:'1'});
    const [stateList,setStateList] = useState([]);
    const [price,setPrice] = useState(0);
    const [compareatprice,setCompareatprice] = useState(0);
    const [type,setType] = useState({name:'Select', value:'0'});
    const [typeList,setTypeList] = useState([]);
    const [sizes,setSizes] = useState([]);
    const [sizesList,setSizesList] = useState([]);
    const [sizesFilter,setSizesFilter] = useState([]);
    const [colors,setColors] = useState([]);
    const [colorsList,setColorsList] = useState([]);
    const [colorsFilter,setColorsFilter] = useState([]);
    const [sku,setSku] = useState('');
    const [deliveryType,setDeliveryType] = useState({name:'Inventory', value:'1'});
    const [deliveryTypeList,setdeliveryTypeList] = useState([{name:'Inventory', value:'1'},{name:'Days', value:'2'},{name:'Months', value:'3'}]);
    const [counter,setCounter] = useState(1);
    const [hasVarients,setHasvarients] = useState(false);
    const [varients,setVarients] = useState([]);
    const [images,setImages] = useState([]);
    const [listCollection,setListCollection] = useState([]);
    const [intrusts,setIntrusts] = useState([]);
    const [recommendations,setRecommendations] = useState([]);
    useEffect(()=>{
        BrandsFunctions.Get(setBrandList);
        ConditionsFunctions.Get(setConditionList);
        CollectionFunctions.GetProductCreate(setAllCategoryList,setCategoryList)
        setStateList([{name:'Fashion', value:'1'},{name:'Art & Lifestyle', value:'2'}])
        ProductTypeFunctions.Get(setTypeList)
        ColorsFunctions.Get((colorListSend)=>{
            setColorsList(colorListSend);
            setColorsFilter(colorListSend);
        })
    },[])
    useEffect(()=>{
      if(page === 0){
        setSku(title)
      }
    },[title])
    useEffect(()=>{
        let filteredSizes = sizesList.filter((item)=> {
            return !sizes.find((itemB)=> {
              return item.value === itemB.value;
            })
        })
        setSizesFilter(filteredSizes);
        ListingCreateFunctions.RefrestVarients(hasVarients,sizes,colors,setVarients)
    },[sizes])
    useEffect(()=>{
        let newcolor = colorsList
        let filteredIntrusts = newcolor.filter((item)=> {
          return !colors.find((itemB)=> {
            return item.value === itemB.value;
          })
        })
        setColorsFilter(filteredIntrusts);
        ListingCreateFunctions.RefrestVarients(hasVarients,sizes,colors,setVarients)
    },[colors])
    useEffect(()=>{
        ListingCreateFunctions.RefrestVarients(hasVarients,sizes,colors,setVarients)
    },[hasVarients])
    const check = (event) => {
        if(page === 0){
            if(title === ""){
              alert("please add title");
              return;
            }
            event()
        }
        else if(page === 1){
            if(price.toString() === "0"){
                alert("add price");
                return;
            }
            if(brand.value === "0"){
                alert("Brand not selected");
                return;
            }
            if(condition.value === "0"){
                alert("Condition not selected");
                return;
            }
            if(category.value === "0"){
                alert("Category not selected");
                return;
            }
            event()
        }
        else if(page === 2){
            if(sizes.length < 1){
                alert("Size is missing");
                return;
            }
            if(colors.length < 1){
                alert("Color is missing");
                return;
            }
            event()
        }
        /*else if(page === 3){
            event()
        }*/
        else if(page === 3){
            if(deliveryType.value === "0"){
              alert("Delivery not selected");
              return;
            }
            event()
        }
        else if(page === 4){
            if(hasVarients){
              var errorVarients = false;
              for (let index = 0; index < varients.length; index++) {
                const element = varients[index];
                if(element.price === "" || element.price === 0 || element.price === undefined ){
                  errorVarients = true;
                }
                if(element.deliverytype.value === "0" ){
                  errorVarients = true;
                }
              }
              if(errorVarients){
                alert("Varient fields are empty");
                return;
              }
              if(varients.length < 1){
                alert("Varient are empty");
                return;
              }
            }
            event()
        }
        else if(page === 5){
            if(intrusts.length < 1){
              alert("Hashtags is missing");
              return;
            }
            event()
        }
        else if(page === 6){
            if(images.length < 1){
                alert("Image is missing");
                return;
            }
            event()
        }
    }
    function add_admin(){
      let stateSend = 0;
      if(User.role === 'individual'){
        stateSend = 1;
      }
      else if(User.role === 'business'){
        if(state.value === '1'){
          stateSend = 2;
        }
        else{
          stateSend = 3;
        }
      }
      else{
        stateSend = 4;
      }
      
      let sizeList = [];
      for (let index = 0; index < sizes.length; index++) {
          const element = sizes[index];
          sizeList.push({
            size: parseInt(element.value)
          })
      }
      let imagesList = [];
      for (let index = 0; index < images.length; index++) {
          const element = images[index];
          imagesList.push({
            url: element
          })
      }
      let colorList = [];
      for (let index = 0; index < colors.length; index++) {
          const element = colors[index];
          colorList.push({
            id: parseInt(element.value)
          })
      }
      let intrustList = [];
      for (let index = 0; index < intrusts.length; index++) {
          const element = intrusts[index];
          intrustList.push({
            id: parseInt(element.value)
          })
      }
      let RList = [];
      for (let index = 0; index < recommendations.length; index++) {
        const element = recommendations[index];
        RList.push({
          id:0,
          listingid:0,
          childid:element.id
        });
      }
  
      var sendVarientList = [];
      for (let index = 0; index < varients.length; index++) {
        const element = varients[index];
        sendVarientList.push({
          title: element.title,
          sku: element.sku,
          price: element.price,
          compareatprice:element.price,
          deliverytype:parseInt(element.deliverytype.value),
          count: element.count,
          size: element.size,
          color: element.color
        })
      }
  
      var sendListCollection = [];
      for (let index = 0; index < listCollection.length; index++) {
        const element = listCollection[index];
        sendListCollection.push({
          id: 0,
          listcollectionid: parseInt(element.value),
          productid: 0,
        })
      }
  
      fetch(ApiUrl.API_URL_Listing, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify({
          title: title,
          discription: discription,
          userid : User.id,
          sku: sku,
          price: price,
          compareatprice: compareatprice,
          brand: parseInt(brand.value),
          condition: parseInt(condition.value),
          type: parseInt(type.value),
          category: parseInt(category.value),
          subcategory: parseInt(subcategory.value),
          state: stateSend,
          colors: colorList,
          sizes: sizeList,
          images: imagesList,
          intrusts: intrustList,
          ListingRecommends: RList,
          counter : counter,
          deliverytype : parseInt(deliveryType.value),
          hasVarients : hasVarients,
          ListingVarients: sendVarientList,
          ListCollectionItems : sendListCollection,
          length : plength,
          height : pheight,
          width : pwidth,
          hscode : hscode,
          weight : weight,
          packing : parseInt(packaging.value)
        })
      })
      .then(res=>res.json())
      .then(data =>{
        if(data.success){
          navigate('/dashboard/listings');
        }
        else{
          alert(data.responce);
        }
      });
    }
  return (
    <div className='product_create_wrapper'>
      <div className='product_create_container'>
        <PageTopbar page = {page} total={8}/>
        <div className='product_create_form_container'>
            <div className='product_create_form_title'>
                <h3>
                    {page === 0 && "Create Product"}
                    {page === 1 && "Some details"}
                    {page === 2 && "How it looks like"}
                    {/*page === 3 && "Shipping"*/}
                    {page === 3 && "Inventory"}
                    {page === 4 && "Varients"}
                    {page === 5 && "Meta"}
                    {page === 6 && "Images"}
                    {page === 7 && "Recommendations"}
                </h3>
            </div>
            {page === 0 &&
                <>
                    <FormInput Lable='Title' Type='text' Placeholder='Enter name' Value={title} setValue={setTitle}/>
                    <FormTextarea Lable='Discription' Placeholder='Enter discription' Value={discription} setValue={setDiscription}/>
                    
                </>
            }
            {page === 1 &&
                <>
                    <div className='admin_forms_row'>
                        <div className='admin_col_33'>
                            <FormInput Lable='Price' Type='number' Placeholder='Enter price' Value={price} setValue={setPrice}/>
                            <FormInput Lable='Compare at Price' Type='number' Placeholder='Enter price before sale' Value={compareatprice} setValue={setCompareatprice}/>
                        </div>
                        <div className='admin_col_33'>
                            <FormSelect Lable='Brand' Value={brand} setValue={setBrand} Options={brandList}/>
                            <FormSelect Lable='Condition' Value={condition} setValue={setCondition} Options={conditionList}/>
                        </div>
                        <div className='admin_col_33'>
                            {User.role === 'business' &&
                            <FormSelect Lable='State' Value={state} setValue={(v)=>{
                                CollectionFunctions.ProductCreateChangeState(v,setCategory,setSubcategory,allcategoryList,setCategoryList,setState)
                            }} Options={stateList}/>
                            }
                            <FormSelect Lable='Category' Value={category} setValue={(v)=>{
                                CollectionFunctions.ProductCreateChangeCategory(v,allcategoryList,setSubcategoryList,setCategory)
                            }} Options={categoryList}/>
                            <FormSelect Lable='Sub Category' Value={subcategory} setValue={setSubcategory} Options={subcategoryList}/>
                        </div>
                    </div>
                </>
            }
            {page === 2 &&
                <>
                    <div className='admin_forms_row'>
                        <div className='admin_col_33'>
                            <FormSelect Lable='Product Type' Value={type} setValue={(v)=>{
                                ProductTypeFunctions.CreateProductChangeType(v,setSizesList,setSizesFilter,setSizes,setType)
                            }} Options={typeList}/>
                        </div>
                        <div className='admin_col_33'>
                            <Sizes sizes={sizes} sizesFilter={sizesFilter} setSizes={setSizes}/>
                        </div>
                        <div className='admin_col_33'>
                            <Colors colors={colors} colorsFilter={colorsFilter} setColors={setColors}/>
                        </div>
                    </div>
                </>
            }
            {/*page === 3 &&
                <>
                    <div className='admin_forms_row'>
                        <div className='admin_col_33'>
                            <FormSelect Lable={'Packaging'} Value = {packaging} setValue={setPackaging} Options = {packagingList} />
                        </div>
                        <div className='admin_col_33'>
                            <FormInput Lable={'Hscode'} Type={'text'} Placeholder={'Enter Hscode'} Value = {hscode} setValue = {setHscode} />
                        </div>
                        <div className='admin_col_33'>
                            <FormInput Lable={'Weight'} Type={'number'} Placeholder={'Enter Weight'} Value = {weight} setValue = {setWeight} />
                        </div>
                    </div>
                    {packaging.value === '2' &&
                    <div className='admin_forms_row'>
                        <div className='admin_col_33'>
                            <FormInput Lable={'Width'} Type={'number'} Placeholder={'Enter Width'} Value = {pwidth} setValue = {setWidth} />
                        </div>
                        <div className='admin_col_33'>
                            <FormInput Lable={'Height'} Type={'number'} Placeholder={'Enter Height'} Value = {pheight} setValue = {setHeight} />
                        </div>
                        <div className='admin_col_33'>
                            <FormInput Lable={'Length'} Type={'number'} Placeholder={'Enter Length'} Value = {plength} setValue = {setLength} />
                        </div>
                    </div>
                    }
                </>
                  */}
            {page === 3 &&
                <>
                    <div className='admin_forms_row'>
                        <div className='admin_col_33'>
                            <FormInput Lable='Product Code (SKU)' Type='text' Placeholder='Enter Product Code' Value={sku} setValue={setSku}/>
                        </div>
                        {User.role === 'business' &&
                        <>
                        <div className='admin_col_33'>
                            <FormSelect Lable='Delivery' Value={deliveryType} setValue={setDeliveryType} Options={deliveryTypeList}/>
                        </div>
                        </>
                        }
                        <div className='admin_col_33'>
                            <FormInput Lable={User.role === 'business' ? 'Count':'Inventory Count'} Type='number' Placeholder='Enter count for inventory/time' Value={counter} setValue={setCounter}/>
                        </div>
                    </div>
                </>
            }
            {page === 4 &&
                <>
                    {hasVarients &&
                        <Varients varients={varients} setVarients={setVarients} deliveryTypeList={deliveryTypeList}/>
                    }
                </>
            }
            {page === 5 &&
                <div className='admin_forms_row'>
                    <div className='admin_col_50'>
                        <Hashtag intrusts={intrusts} setIntrusts={setIntrusts} />
                    </div>
                    <div className='admin_col_50'>
                        <ListCollection colors={listCollection} setColors={setListCollection}/>
                    </div>
                </div>
            }
            {page === 6 &&
                <ImagePicker Images={images} SetImages={setImages}/>
            }
            {page === 7 &&
                <Recommendations recommendations={recommendations} setRecommendations={setRecommendations}/>
            }
            <PageNav page={page} hasVarients={hasVarients} setPage={setPage} setHasvarients={setHasvarients} sizes={sizes} colors = {colors} add_admin={add_admin} check={check}/>
        </div>
      </div>
    </div>
  )
}

export default Index
